import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, map, finalize } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly _counter$ = new BehaviorSubject<number>(0);

  /** Публичный поток: true если есть хотя бы одна активная загрузка */
  readonly loading$: Observable<boolean> = this._counter$
    .pipe(map(c => c > 0), distinctUntilChanged());

  /** Включить индикатор (счетчик++) */
  show(): void {
    this._counter$.next(this._counter$.value + 1);
  }

  /** Выключить индикатор (счетчик--) */
  hide(): void {
    const next = Math.max(this._counter$.value - 1, 0);
    this._counter$.next(next);
  }

  /** Установить состояние напрямую */
  set(isLoading: boolean): void {
    isLoading ? this.show() : this.hide();
  }

  /** Обертка: автоматически покажет/скроет индикатор вокруг Observable */
  with<T>(obs: Observable<T>): Observable<T> {
    this.show();
    return obs.pipe(finalize(() => this.hide()));
  }
}
